import { render, staticRenderFns } from "./EFaixasDeDesconto.vue?vue&type=template&id=5b2cc646"
import script from "./EFaixasDeDesconto.vue?vue&type=script&lang=js"
export * from "./EFaixasDeDesconto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports